import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_GRID_LAYOUT_DISTRIBUTION = {
  Cols1: "cols-1",
  Cols2: "cols-2",
  Cols4: "cols-4",
  Cols6: "cols-6",
  Split: "split",
  Split21: "split-2-1",
  Split12: "split-1-2",
} as const;

export type DSGridLayoutDistribution = ObjectValues<typeof DS_GRID_LAYOUT_DISTRIBUTION>;
